import { useQuery } from 'react-query';

import type { QueryFunction } from '@frontend/api';
import { useRequest } from '@frontend/api';

import type { QuotesOverviewQueryKeyType } from './getQuotesOverviewQueryKey';
import { getQuotesOverviewQueryKey } from './getQuotesOverviewQueryKey';
import type {
  QuotesOverviewQueryParams,
  QuotesOverviewResponse,
} from './types';

export const useGetQuotesOverview: QueryFunction<
  QuotesOverviewResponse,
  [],
  QuotesOverviewQueryKeyType,
  QuotesOverviewQueryParams
> = ({ requestOptions, queryOptions, query } = {}) => {
  const request = useRequest(requestOptions);

  return useQuery({
    keepPreviousData: true,
    ...queryOptions,
    queryKey: getQuotesOverviewQueryKey(query),
    queryFn: ({ signal }) =>
      request<QuotesOverviewResponse>('/quotes/overview', {
        query,
        init: {
          method: 'GET',
          signal,
        },
      }),
  });
};
